module.exports = __webpack_public_path__ + "img/tasks_white.694004b5.png";